import React, { useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import '../style/datatable.css';
import { Button } from "flowbite-react";
import { FaSearch } from "react-icons/fa";


const FilterComponent = ({ onFilter, onClear, filterText }) => (
    <>
      <input
        className="text-field"
        placeholder="Filter By Title"
        value={filterText}
        onChange={onFilter}
      />
      <Button className="clear-button" onClick={onClear}>
        <FaSearch />
      </Button>
    </>
  );
  

const ReusableDataTable = ({ title, columns, data,noDataMessage }) => {
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  
    const filteredItems = data.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(filterText.toLowerCase())
      )
    );
  
    const subHeaderComponentMemo = useMemo(() => {
      const handleClear = () => {
        if (filterText) {
          setResetPaginationToggle(!resetPaginationToggle);
          setFilterText("");
        }
      };
  
      return (
        <FilterComponent
          onFilter={(e) => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
        />
      );
    }, [filterText, resetPaginationToggle]);
  
    return (
      <DataTable
        title={title}
        columns={columns}
        data={filteredItems}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        persistTableHead
        striped
        highlightOnHover
        noDataComponent={
                <div className="text-center text-gray-00 font-semibold py-4">
                    {noDataMessage || "No records found."}
                </div>
            }
      />
    );
  };

export default ReusableDataTable;
